<template>
  <div v-loadmore="loadMore">
    <search :change="change" class="search"></search>
    <div class="content">
      <!-- <div class="item border-bottom" v-if="dkList.length">
        <card-dk :data="dkList"></card-dk>
      </div> -->
      <div>
        <card-teacher v-for="item in dkList" :key="item.id" :data="item" class="item"></card-teacher>
      </div>
      <no-search-data v-if="shownodata"></no-search-data>
      <loading :more="more" :loaded="loaded" v-if="dkList.length!==0"></loading>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import Scroll from '../base/scroll/scroll'
// import CardDk from '../card/card-dk'
import CardTeacher from '../card/card-teacher'
import Search from 'components/search/search'
import {getDkList} from '@/api/daka.js'
import Loading from '../base/loading/loading2'
import NoSearchData from '../base/loading/no-search-data'
import {RES_OK, PAGE_SIZE} from '@/api/config'
export default {
  components: {
    Scroll,
    Search,
    // CardDk,
    CardTeacher,
    Loading,
    NoSearchData
  },
  data() {
    return {
      page: 1,
      dkList: [],
      loaded: true,
      more: true,
      keyword: '',
      ticket: 0,
      shownodata: false
    }
  },
  methods: {
    change(val) {
      if (val === this.keyword) return
      this.keyword = val
      let ticket = ++this.ticket
      if (this.keyword.length === 0) {
        this.dkList = []
        return
      }
      // 隐藏没有数据的提示
      this.shownodata = false
      getDkList(1, PAGE_SIZE, 0, this.keyword).then((res) => {
        if (this.ticket !== ticket) return
        let data = res.data
        if (data && data.code === RES_OK && data.data) {
          this.loaded = true
          this.more = data.data.length >= PAGE_SIZE
          this.page = 2
          this.dkList = data.data
          if (this.dkList.length === 0) {
            this.shownodata = true
          }
        }
      })
    },
    _getDkList(page) {
      getDkList(page, PAGE_SIZE, this.keyword).then((res) => {
        let data = res.data
        if (data && data.code === RES_OK && data.data) {
          if (data.data.length) {
            this.dkList.push(...data.data)
            this.loaded = true
            this.page++
          }
          // 加载完毕
          this.more = data.data.length >= PAGE_SIZE
        }
      })
    },
    loadMore() {
      if (this.keyword.length === 0) return
      if (this.more && this.loaded) {
        this.loaded = false
        this._getDkList(this.page)
      }
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .search
    position fixed
    top 0
    left 0
    width 100%
    background #ffffff
    z-index 9
  .content
    padding-top: size(136 + 30)
    padding-bottom size(40)
    padding-left size(30)
    padding-right size(30)
  .item
    margin-bottom size(40)!important
</style>



// WEBPACK FOOTER //
// src/components/daka/search.vue